import App from '@components/locations/App.vue';  
import { generateApplication } from '@helpers/generate_component.js';
import { generateAxiosInstance } from '@helpers/axios_provider.js';

const axios = generateAxiosInstance();

const injections = [{
  name: '$axios',
  module: axios
}, {
  name: 'locale',
  module: locale  
}];

const props = {
  
};

generateApplication(App, "#locations-app", { injections, props });

